var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"play-back-list"},[_c('p',{staticClass:"month-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"live-item-parent"},[_c('play-back-item',{attrs:{"itemData":_vm.lessonData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }